export const MAX_ADD_TO_MEMORY_TEXT_LENGTH = 2000

export function prepareMemoryTextForSubmission(text: string): {
  text: string
  wasTruncated: boolean
} {
  if (text.length <= MAX_ADD_TO_MEMORY_TEXT_LENGTH) {
    return { text, wasTruncated: false }
  }

  const ellipsis = "…"
  const truncatedText = text.slice(0, MAX_ADD_TO_MEMORY_TEXT_LENGTH - ellipsis.length).trimEnd()

  return {
    text: `${truncatedText}${ellipsis}`,
    wasTruncated: true,
  }
}
